import { useAuth } from "@providers/AuthProvider";
import { useState } from "react";

export function useUserIsSetupCorrectly() {
    const {user, signOut, can} = useAuth();

    return !user || !!user.contact;
}
